import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  imports: [RouterModule],
  selector: 'spl-client-app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
